import React from 'react';
import { Theme } from '../Theme';

type Props = {
    userType?: string;
};

export function getUserTypeLabel(userType?: string): string {
    if (!userType) {
        return '';
    }

    switch (userType.toLowerCase()) {
        case 'care_recipient':
        case 'client':
            return 'Care recipient';
        case 'carer':
            return 'Carer';
        case 'therapist':
            return 'Therapist';
        case 'admin':
            return 'Admin';
        case 'super':
            return 'Super';
        default:
            return userType;
    }
}

function getTagStyle(label: string): React.CSSProperties | null {
    switch (label) {
        case 'Carer':
            return { backgroundColor: '#FFE5A9', color: '#6E3A33' };
        case 'Care recipient':
            return { backgroundColor: '#FFC6E8', color: '#7A3B5A' };
        case 'Therapist':
            return { backgroundColor: '#A7D7FF', color: '#2B5C86' };
        default:
            return null;
    }
}

export function UserTypeTag({ userType }: Props) {
    const label = getUserTypeLabel(userType);
    const tagStyle = getTagStyle(label);

    if (!label) {
        return null;
    }

    if (!tagStyle) {
        return <span>{label}</span>;
    }

    return (
        <span style={{ ...styles.tag, ...tagStyle }}>
            {label}
        </span>
    );
}

const styles: Record<string, React.CSSProperties> = {
    tag: {
        ...Theme.Fonts.body,
        display: 'inline-flex',
        alignItems: 'center',
        padding: '5px 10px',
        borderRadius: '9px',
        fontWeight: 600,
        lineHeight: 1.1,
        whiteSpace: 'nowrap',
    },
};
